window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

window.FazendaRP.Pages.whatsapp = {
    activeTab: 'dashboard', // 'dashboard', 'config', 'inbox', 'comandos'
    container: null,

    render: async function (container) {
        this.container = container;

        const styles = `
            <style>
                .whatsapp-tab-nav { display: flex; gap: 5px; border-bottom: 2px solid #e2e8f0; margin-bottom: 25px; overflow-x: auto; }
                .whatsapp-tab-btn { padding: 12px 20px; background: none; border: none; font-weight: 600; color: #64748b; cursor: pointer; font-size: 1rem; border-bottom: 3px solid transparent; margin-bottom: -2px; transition: all 0.2s; white-space: nowrap; display: flex; align-items: center; gap: 8px; }
                .whatsapp-tab-btn:hover { color: #25D366; }
                .whatsapp-tab-btn.active { color: #25D366; border-bottom-color: #25D366; }
                
                .whatsapp-card { background: white; border-radius: 12px; padding: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin-bottom: 20px; border: 1px solid #e2e8f0; }
                .metric-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 15px; margin-bottom: 20px; }
                .metric-card { background: white; padding: 20px; border-radius: 10px; border-left: 4px solid #25D366; box-shadow: 0 2px 4px rgba(0,0,0,0.02); border: 1px solid #f1f5f9; }
                .metric-title { font-size: 0.85rem; color: #64748b; font-weight: 600; text-transform: uppercase; }
                .metric-value { font-size: 1.8rem; font-weight: 700; color: #1e293b; margin: 5px 0; }
            </style>
        `;

        container.innerHTML = styles + `
            <div id="whatsapp-module" style="max-width: 1200px; margin: 0 auto; padding-bottom: 50px;">
                
                <!-- HEADER -->
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
                    <div>
                        <h2 style="margin:0; color:#0f172a;"><i class="fab fa-whatsapp" style="color:#25D366;"></i> WhatsApp Bot</h2>
                        <p style="margin:5px 0 0 0; color:#64748b;">Gestão e Configuração</p>
                    </div>
                    <div style="text-align:right;">
                        <div id="bot-status" style="font-size:1.5rem; font-weight:bold; color:#0f172a;">🟢 Online</div>
                        <div style="color:#64748b; font-size:0.9rem;">Bot Status</div>
                    </div>
                </div>

                <!-- TABS -->
                <nav class="whatsapp-tab-nav">
                    <button class="whatsapp-tab-btn active" onclick="window.FazendaRP.Pages.whatsapp.switchTab('dashboard')"><i class="fas fa-chart-pie"></i> Dashboard</button>
                    <button class="whatsapp-tab-btn" onclick="window.FazendaRP.Pages.whatsapp.switchTab('config')"><i class="fas fa-cog"></i> Configurações</button>
                    <button class="whatsapp-tab-btn" onclick="window.FazendaRP.Pages.whatsapp.switchTab('comandos')"><i class="fas fa-terminal"></i> Comandos</button>
                </nav>

                <!-- CONTENT CONTAINERS -->
                <div id="tab-dashboard" class="whatsapp-tab-content"></div>
                <div id="tab-config" class="whatsapp-tab-content" style="display:none;"></div>
                <div id="tab-comandos" class="whatsapp-tab-content" style="display:none;"></div>

            </div>
        `;

        this.switchTab(this.activeTab);
    },

    switchTab: function (tabId) {
        this.activeTab = tabId;

        // Update Nav
        document.querySelectorAll('.whatsapp-tab-btn').forEach(btn => btn.classList.remove('active'));
        const activeBtn = document.querySelector(`.whatsapp-tab-btn[onclick*="${tabId}"`);
        if (activeBtn) activeBtn.classList.add('active');

        // Toggle Content
        document.querySelectorAll('.whatsapp-tab-content').forEach(el => el.style.display = 'none');
        const target = document.getElementById('tab-' + tabId);
        if (target) {
            target.style.display = 'block';
            this.renderTabContent(tabId, target);
        }
    },

    renderTabContent: function (tabId, container) {
        switch (tabId) {
            case 'dashboard':
                this.renderDashboard(container);
                break;
            case 'config':
                this.renderConfig(container);
                break;
            case 'comandos':
                this.renderComandos(container);
                break;
        }
    },

    // --- DASHBOARD ---
    renderDashboard: async function (container) {
        container.innerHTML = `
            <div class="metric-grid">
                <div class="metric-card">
                    <div class="metric-title">Total Comandos</div>
                    <div class="metric-value" style="color:#25D366;">14</div>
                    <div class="metric-sub" style="font-size:0.8rem; color:#94a3b8;">Disponíveis</div>
                </div>
                <div class="metric-card">
                    <div class="metric-title">Inscritos Clima</div>
                    <div class="metric-value" id="total-clima" style="color:#0ea5e9;">-</div>
                    <div class="metric-sub" style="font-size:0.8rem; color:#94a3b8;">Previsão diária</div>
                </div>
                <div class="metric-card">
                    <div class="metric-title">Alertas Ativos</div>
                    <div class="metric-value" id="total-alertas" style="color:#f59e0b;">-</div>
                    <div class="metric-sub" style="font-size:0.8rem; color:#94a3b8;">Usuários configurados</div>
                </div>
                <div class="metric-card">
                    <div class="metric-title">Pré-Lançamentos</div>
                    <div class="metric-value" id="total-pending" style="color:#ef4444;">-</div>
                    <div class="metric-sub" style="font-size:0.8rem; color:#94a3b8;">Aguardando aprovação</div>
                </div>
            </div>

            <div class="whatsapp-card">
                <h4 style="margin:0 0 15px 0; color:#374151; display:flex; align-items:center; gap:10px;">
                    <i class="fas fa-info-circle" style="color:#25D366;"></i> Recursos Disponíveis
                </h4>
                <div style="display:grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap:15px;">
                    <div style="border-left:3px solid #25D366; padding-left:15px;">
                        <strong>✅ Comandos Rápidos</strong>
                        <p style="margin:5px 0; color:#64748b; font-size:0.9rem;">11 comandos de consulta (saldo, contas, DRE, etc.)</p>
                    </div>
                    <div style="border-left:3px solid #25D366; padding-left:15px;">
                        <strong>🌤️ Previsão Climática</strong>
                        <p style="margin:5px 0; color:#64748b; font-size:0.9rem;">Comparativo ECMWF vs GFS (15 dias)</p>
                    </div>
                    <div style="border-left:3px solid #25D366; padding-left:15px;">
                        <strong>🔔 Alertas Proativos</strong>
                        <p style="margin:5px 0; color:#64748b; font-size:0.9rem;">Contas, estoque e clima favorável</p>
                    </div>
                    <div style="border-left:3px solid #25D366; padding-left:15px;">
                        <strong>📷 OCR de Notas</strong>
                        <p style="margin:5px 0; color:#64748b; font-size:0.9rem;">Extração automática de dados</p>
                    </div>
                    <div style="border-left:3px solid #25D366; padding-left:15px;">
                        <strong>💰 Pré-Lançamentos</strong>
                        <p style="margin:5px 0; color:#64748b; font-size:0.9rem;">Sistema de aprovação no Inbox</p>
                    </div>
                    <div style="border-left:3px solid #25D366; padding-left:15px;">
                        <strong>🤖 IA Integrada</strong>
                        <p style="margin:5px 0; color:#64748b; font-size:0.9rem;">Gemini AI para análise e extração</p>
                    </div>
                </div>
            </div>

            <div class="whatsapp-card">
                <h4 style="margin:0 0 15px 0; color:#374151;">Ações Rápidas</h4>
                <div style="display:flex; gap:10px; flex-wrap:wrap;">
                    <button onclick="window.FazendaRP.Pages.whatsapp.switchTab('config')" class="btn btn-primary" style="background:#25D366; border:none;">
                        <i class="fas fa-cog"></i> Configurar Alertas
                    </button>
                    <button onclick="window.FazendaRP.Pages.whatsapp.switchTab('comandos')" class="btn btn-secondary">
                        <i class="fas fa-terminal"></i> Ver Comandos
                    </button>
                    <button onclick="window.FazendaRP.loadPage('financeiro'); setTimeout(() => document.querySelector('.submenu-item[data-tab=\\\"inbox\\\"]')?.click(), 200)" class="btn btn-secondary">
                        <i class="fas fa-inbox"></i> Abrir Inbox
                    </button>
                </div>
            </div>
        `;

        // Load Stats
        this.loadStats();
    },

    loadStats: async function () {
        try {
            // Total clima subscriptions
            const { count: climaCount } = await window.FazendaRP.supabase
                .from('bot_weather_subscriptions')
                .select('*', { count: 'exact', head: true })
                .eq('active', true);

            document.getElementById('total-clima').textContent = climaCount || 0;

            // Total alert preferences
            const { count: alertasCount } = await window.FazendaRP.supabase
                .from('bot_alert_preferences')
                .select('*', { count: 'exact', head: true });

            document.getElementById('total-alertas').textContent = alertasCount || 0;

            // Total pending pre-lancamentos
            const { count: pendingCount } = await window.FazendaRP.supabase
                .from('financeiro_pre_lancamentos')
                .select('*', { count: 'exact', head: true })
                .eq('status', 'pendente');

            document.getElementById('total-pending').textContent = pendingCount || 0;

        } catch (e) {
            console.error('Error loading stats:', e);
        }
    },

    // --- CONFIGURAÇÕES ---
    renderConfig: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:20px;"><i class="fas fa-spinner fa-spin"></i> Carregando...</div>';

        // Load current user config (simulating single user for now)
        const PHONE = '273361968050346@lid'; // Your number from previous logs

        const { data: prefs } = await window.FazendaRP.supabase
            .from('bot_alert_preferences')
            .select('*')
            .eq('phone_number', PHONE)
            .single();

        const config = prefs || {
            alertas_contas: false,
            alertas_estoque: false,
            alertas_clima: false,
            horario_envio: '07:00'
        };

        container.innerHTML = `
            <div class="whatsapp-card">
                <h4 style="margin:0 0 20px 0; color:#374151;"><i class="fas fa-bell" style="color:#f59e0b;"></i> Configuração de Alertas Diários</h4>
                
                <div style="background:#fffbeb; border-left:4px solid #f59e0b; padding:15px; margin-bottom:20px; border-radius:4px;">
                    <strong>⏰ Horário de Envio:</strong>
                    <p style="margin:5px 0; color:#78350f;">Os alertas serão enviados automaticamente todos os dias às <strong>${config.horario_envio}</strong>.</p>
                </div>
                
                <div style="display:grid; gap:15px;">
                    <label style="display:flex; align-items:center; gap:10px; padding:15px; background:#f9fafb; border-radius:8px; cursor:pointer; border:2px solid ${config.alertas_contas ? '#25D366' : '#e5e7eb'};">
                        <input type="checkbox" id="alert-contas" ${config.alertas_contas ? 'checked' : ''} style="width:20px; height:20px;">
                        <div style="flex:1;">
                            <strong>⚠️ Alertas de Contas</strong>
                            <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Avisar sobre contas vencendo nos próximos 3 dias</p>
                        </div>
                    </label>
                    
                    <label style="display:flex; align-items:center; gap:10px; padding:15px; background:#f9fafb; border-radius:8px; cursor:pointer; border:2px solid ${config.alertas_estoque ? '#25D366' : '#e5e7eb'};">
                        <input type="checkbox" id="alert-estoque" ${config.alertas_estoque ? 'checked' : ''} style="width:20px; height:20px;">
                        <div style="flex:1;">
                            <strong>📦 Alertas de Estoque</strong>
                            <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Avisar quando estoque estiver < 20% do consumo mensal</p>
                        </div>
                    </label>
                    
                    <label style="display:flex; align-items:center; gap:10px; padding:15px; background:#f9fafb; border-radius:8px; cursor:pointer; border:2px solid ${config.alertas_clima ? '#25D366' : '#e5e7eb'};">
                        <input type="checkbox" id="alert-clima" ${config.alertas_clima ? 'checked' : ''} style="width:20px; height:20px;">
                        <div style="flex:1;">
                            <strong>☀️ Alertas de Clima Favorável</strong>
                            <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Informar dias ideais para aplicação (< 20% chance de chuva)</p>
                        </div>
                    </label>
                </div>
                
                <div style="margin-top:20px; padding-top:20px; border-top:1px solid #e5e7eb;">
                    <button onclick="window.FazendaRP.Pages.whatsapp.saveConfig()" class="btn btn-primary" style="background:#25D366; border:none;">
                        <i class="fas fa-save"></i> Salvar Configurações
                    </button>
                </div>
            </div>

            <div class="whatsapp-card">
                <h4 style="margin:0 0 15px 0; color:#374151;"><i class="fas fa-play-circle" style="color:#3b82f6;"></i> Testar Alertas</h4>
                <p style="color:#64748b; margin-bottom:15px;">Envie os alertas manualmente para testar (sem aguardar o horário agendado).</p>
                <button onclick="window.FazendaRP.Pages.whatsapp.testAlerts()" class="btn btn-secondary">
                    <i class="fas fa-paper-plane"></i> Enviar Alertas Agora
                </button>
            </div>
        `;
    },

    saveConfig: async function () {
        const PHONE = '273361968050346@lid';

        const config = {
            phone_number: PHONE,
            alertas_contas: document.getElementById('alert-contas').checked,
            alertas_estoque: document.getElementById('alert-estoque').checked,
            alertas_clima: document.getElementById('alert-clima').checked
        };

        const { error } = await window.FazendaRP.supabase
            .from('bot_alert_preferences')
            .upsert([config], { onConflict: 'phone_number' });

        if (error) {
            window.FazendaRP.Toast.show('error', 'Erro', error.message);
        } else {
            window.FazendaRP.Toast.show('success', 'Salvo!', 'Configurações atualizadas com sucesso.');
            this.renderConfig(document.getElementById('tab-config'));
        }
    },

    testAlerts: function () {
        window.FazendaRP.Toast.show('info', 'Executando', 'Rodando script send_alerts.js...');
        alert('Para testar, execute no terminal:\n\nnode bot/send_alerts.js');
    },

    // --- COMANDOS ---
    renderComandos: function (container) {
        container.innerHTML = `
            <div class="whatsapp-card">
                <h4 style="margin:0 0 20px 0; color:#374151;"><i class="fas fa-terminal" style="color:#25D366;"></i> Lista de Comandos Disponíveis</h4>
                
                <div style="display:grid; gap:20px;">
                    
                    <!-- Financeiro -->
                    <div>
                        <h5 style="color:#3b82f6; margin:0 0 10px 0;"><i class="fas fa-wallet"></i> Financeiro</h5>
                        <div style="display:grid; gap:10px;">
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #3b82f6;">
                                <code style="color:#25D366; font-weight:bold;">/saldo</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Mostra saldos de todas as contas bancárias</p>
                            </div>
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #3b82f6;">
                                <code style="color:#25D366; font-weight:bold;">/contas</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Lista contas a pagar nos próximos 7 dias</p>
                            </div>
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #3b82f6;">
                                <code style="color:#25D366; font-weight:bold;">/dre</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">DRE do mês atual com top 5 categorias</p>
                            </div>
                        </div>
                    </div>

                    <!-- Operacional -->
                    <div>
                        <h5 style="color:#10b981; margin:0 0 10px 0;"><i class="fas fa-tractor"></i> Operacional</h5>
                        <div style="display:grid; gap:10px;">
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #10b981;">
                                <code style="color:#25D366; font-weight:bold;">/safra</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Status da safra ativa (área, custos, resultado)</p>
                            </div>
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #10b981;">
                                <code style="color:#25D366; font-weight:bold;">/maquinas</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Top 5 máquinas por consumo (últimos 30 dias)</p>
                            </div>
                        </div>
                    </div>

                    <!-- Clima -->
                    <div>
                        <h5 style="color:#0ea5e9; margin:0 0 10px 0;"><i class="fas fa-cloud-sun"></i> Clima</h5>
                        <div style="display:grid; gap:10px;">
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #0ea5e9;">
                                <code style="color:#25D366; font-weight:bold;">/chuva</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Histórico de chuva dos últimos 7 dias</p>
                            </div>
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #0ea5e9;">
                                <code style="color:#25D366; font-weight:bold;">/previsao</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Previsão 15 dias comparando ECMWF vs GFS</p>
                            </div>
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #0ea5e9;">
                                <code style="color:#25D366; font-weight:bold;">/clima</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Inscrever para receber previsão diária às 7h</p>
                            </div>
                        </div>
                    </div>

                    <!-- Alertas -->
                    <div>
                        <h5 style="color:#f59e0b; margin:0 0 10px 0;"><i class="fas fa-bell"></i> Alertas</h5>
                        <div style="display:grid; gap:10px;">
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #f59e0b;">
                                <code style="color:#25D366; font-weight:bold;">/alertas</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Ver/configurar alertas automáticos</p>
                            </div>
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #f59e0b;">
                                <code style="color:#25D366; font-weight:bold;">/alertas on</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Ativar todos os alertas</p>
                            </div>
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #f59e0b;">
                                <code style="color:#25D366; font-weight:bold;">/alertas [tipo] off</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Desativar alerta específico (contas, estoque, clima)</p>
                            </div>
                        </div>
                    </div>

                    <!-- Ajuda -->
                    <div>
                        <h5 style="color:#6b7280; margin:0 0 10px 0;"><i class="fas fa-question-circle"></i> Outros</h5>
                        <div style="display:grid; gap:10px;">
                            <div style="background:#f9fafb; padding:12px; border-radius:6px; border-left:3px solid #6b7280;">
                                <code style="color:#25D366; font-weight:bold;">/help</code>
                                <p style="margin:5px 0 0 0; color:#64748b; font-size:0.9rem;">Lista todos os comandos disponíveis</p>
                            </div>
                        </div>
                    </div>

                    <!-- Funções Naturais -->
                    <div style="background:#ecfdf5; padding:15px; border-radius:8px; border:1px solid #a7f3d0;">
                        <h5 style="color:#059669; margin:0 0 10px 0;"><i class="fas fa-comments"></i> Linguagem Natural</h5>
                        <p style="margin:0; color:#064e3b; font-size:0.9rem;">Você também pode enviar mensagens normais:</p>
                        <ul style="margin:10px 0 0 20px; color:#047857;">
                            <li>"Paguei luz 150 reais" → Cria pré-lançamento</li>
                            <li>"Comprei 10 sacos de adubo a 50 reais" → Com itens</li>
                            <li>"Quanto gastei com fornecedor X?" → Consulta IA</li>
                            <li>📷 Foto de nota → OCR automático</li>
                            <li>"Hoje choveu 15mm" → Registra chuva</li>
                        </ul>
                    </div>

                </div>
            </div>
        `;
    }
};
